import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { baseURL } from "../../../custom/api";
import { toFarsiNumber } from "../../../custom/helpers";
import { useGroupApi } from "../../groups/groupApi";
import "../../../styles/DailyFood.css";

// "Today's food recommendation": one recipe per day from the existing recipe database.
// The server picks it once a day (rotating through categories) and caches it, so this is a single light request.
export default function DailyRecommendation() {
  const { call } = useGroupApi();
  const [state, setState] = useState({ status: "loading", rec: null });

  const load = useCallback(async () => {
    setState({ status: "loading", rec: null });
    try {
      const data = await call("recommendations/today", { method: "GET" });
      setState(data && data.recommendation ? { status: "ok", rec: data.recommendation } : { status: "empty", rec: null });
    } catch (e) {
      setState({ status: "error", rec: null });
    }
  }, [call]);

  useEffect(() => {
    load();
  }, [load]);

  if (state.status === "empty") return null; // nothing to recommend yet: don't leave a hole in Home

  if (state.status === "loading") {
    return <div className="dfSkeleton" aria-busy="true" aria-label="در حال بارگذاری پیشنهاد امروز" />;
  }

  if (state.status === "error") {
    return (
      <div className="dfError yekan" role="status">
        پیشنهاد امروز بارگذاری نشد.
        <div>
          <button type="button" className="dfRetry" onClick={load}>تلاش دوباره</button>
        </div>
      </div>
    );
  }

  const { rec } = state;
  return (
    <>
      <div className="dfHeading">
        <h2 className="yekan">پیشنهاد غذای امروز</h2>
      </div>
      <article className="dfCard">
        <Link to={rec.locked ? "/subscription" : `/recipe/${rec.recipe_id}`} className="dfImgWrap" tabIndex={-1} aria-hidden="true">
          <img className="dfImg" src={`${baseURL}/${rec.image_path}`} alt="" loading="lazy" />
          <span className="dfBadge">امروز برای تو</span>
        </Link>
        <div className="dfBody">
          <h3 className="dfName yekan">{rec.recipe_name}</h3>
          <div className="dfMeta">
            {rec.category && <span className="dfChip dfChip-accent">{rec.category}</span>}
            {rec.cooking_duration ? <span className="dfChip">{toFarsiNumber(rec.cooking_duration)} دقیقه</span> : null}
          </div>
          <Link to={rec.locked ? "/subscription" : `/recipe/${rec.recipe_id}`} className="dfCta">
            {rec.locked ? "فعال‌سازی اشتراک" : "دیدن دستور پخت"}
          </Link>
        </div>
      </article>
    </>
  );
}
